import React from 'react';
import Logo from './Logo';
import SectionKicker from './SectionKicker';
import ClickMark from './ClickMark';
import {IconArrowUpRight} from './Icons';
import {BOOK_URL,SIGNIN_URL,EMAIL_US} from '../siteConfig';

function Footer() {
  return (
    <footer>
      <div className="footer-cta">
        <ClickMark className="foot-mark fo-a" color="#caa1eb" />
        <ClickMark className="foot-mark fo-b" color="#f7a38c" />
        <ClickMark className="foot-mark fo-c" color="#94b6e8" />
        <SectionKicker tone={3} light>Ready when you are</SectionKicker>
        <h2>Your tech, handled.<br /><em>So you can run your business.</em></h2>
        <a className="light-button" href={BOOK_URL}>
          Book a free call <IconArrowUpRight />
        </a>
      </div>
      <div className="footer-bottom">
        <a className="brand footer-brand" href="#/" aria-label="Handle My Tech home"><Logo light /></a>
        <div className="footer-links">
          <a className="footer-link" href="#/services">Services</a>
          <a className="footer-link" href="#/how-it-works">How it works</a>
          <a className="footer-link" href="#/pricing">Pricing</a>
          <a className="footer-link" href={EMAIL_US}>Email us</a>
          <a className="footer-link" href={SIGNIN_URL}>Sign in</a>
          <a className="footer-link" href="#/privacy">Privacy</a>
          <a className="footer-link" href="#/terms">Terms</a>
        </div>
        <span>© 2026 Handle My Tech · Surprise, Arizona</span>
      </div>
    </footer>
  );
}

export default Footer;
